import esContent from './alerts.es';

export default {
  ...esContent,
};
